export const applyListInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case "applyListInfo":
      return {
        ...state,
        applyListInfo: action.data,
      };
    case "page":
      return {
        ...state,
        page: action.data,
      };
    default:
      return state;
  }
};
